
  import { Component, Vue } from 'vue-property-decorator';
  import { mapGetters } from 'vuex';

  import Input from '@/components/Core/Input.vue';

  import { IErrorModel } from '@/models/errors.model';
  import { IDeletionTypeModel, IDeletionTypesResultModel, IValidatePasswordModel, IValidatePasswordResultModel, IDeleteUserModel } from '@/models/account.model';

  import accountService from '@/services/account.service';
  import errorsService from '@/services/errors.service';
  import { IRequestResultModel } from '@/models/request.model';
  import { ITokenModel } from '@/models/token.model';
  import { IUserModel } from '@/models/account.model';

  @Component({
    components: {
      Input
    },
    computed: {
      ...mapGetters([
        'user',
        'token',
        'isLoading',
      ])
    }
  })
  export default class DeletionRequest extends Vue {
    data() {
      return {
        currentStep: 1,
        password: '',
        selectedReason: null,
        otherReason: null,
        hasErrors: false,
        hasCancelButton: true,
        isConfirmPasswordLoading: false,
        isCancelDeleteLoading: false,
        isDeleteLoading: false,
        checkPassword: true,
        errors: new Array<IErrorModel>(),
        deletionTypesList: [] as Array<IDeletionTypeModel>,
        deletionSubtitle: "Are you sure?",
        deletionDescription: "Please be aware that after the deletion your account and associated data cannot be restored.",
        deletionSubdescription: "Deletion of your account will not affect any NDA or other contract signed.",
        deletionButtonLabel: "Delete",
        deletionHasLink: false,
        deletionLink: '',
      }
    };

    created() {
      this.setData();
      this.setDeletionTypesList();
    };

    setDeletionTypesList() {
      this.$data.isLoading = true;

      const url: string = this.$data.RCEnvironment.VUE_APP_ACCOUNT_API_URL + "deletion/types";
      accountService.get<IDeletionTypesResultModel>(this, url)
        .then(response => {
          this.$data.isLoading = false;
          this.$set(this.$data, "deletionTypesList", response.DeletionTypes);
        })
        .catch(error => {
          this.$data.isLoading = false;
          errorsService.handleErrors(this, error);
        });
    }

    updatePasswordValue(parameterName: string, value: string) {
      this.$data.password = value;
    }

    confirmPassword() {
      if (this.$data.isConfirmPasswordLoading) {
        return;
      }

      this.$data.isConfirmPasswordLoading = true;
      this.$data.errors = new Array<IErrorModel>();
      this.$data.hasErrors = false;

      setTimeout(() => {
        const url: string = this.$data.RCEnvironment.VUE_APP_ACCOUNT_API_URL + "password/validate/user/" + this.$store.getters.user.Id;

        accountService.post<IValidatePasswordModel, IValidatePasswordResultModel>(this, url, { Password: this.$data.password }, { headers: { Authorization: "Bearer " + this.$store.getters.token.Value } })
          .then(() => {
            this.$data.currentStep++;
            this.$data.isConfirmPasswordLoading = false;
          })
          .catch(error => {
            this.$data.hasErrors = true;
            this.$data.errors = error.data.ErrorMessages;
            this.$data.isConfirmPasswordLoading = false;
          });
      }, 300);
    }

    skipReason() {
      this.$data.selectedReason = null;
      this.$data.otherReason = '';
      this.$data.currentStep++;
    }

    confirmReason() {
      this.$data.currentStep++;
    }

    cancelDeletion() {
      this.$data.isCancelDeleteLoading = true;

      this.$data.password = "";
      this.$data.selectedReason = null;
      this.$data.otherReason = null;
      this.$data.currentStep = 1;
      this.setData();

      this.$data.isCancelDeleteLoading = false;
    }

    confirmDeletion() {
      if (this.$data.deletionHasLink) {
        window.open(this.$data.deletionLink, '_blank');

        return;
      }


      this.$store.dispatch("updateIsLoading", true);
      this.$data.isDeleteLoading = true;

      const url = !this.$data.checkPassword ?
        this.$data.RCEnvironment.VUE_APP_ACCOUNT_API_URL + "deletion/partner/user/" + this.$store.getters.user.Id :
        this.$data.RCEnvironment.VUE_APP_ACCOUNT_API_URL + "deletion/user/" + this.$store.getters.user.Id;

      const form = {
        Password: this.$data.password,
        Email: this.$store.getters.user.Email,
        Id_DeletionType: this.$data.selectedReason,
        DeletionReason: this.$data.otherReason
      } as IDeleteUserModel;

      if (!this.$data.checkPassword) {
        form.Password = this.$data.password;
      }

      accountService.post<IDeleteUserModel, IRequestResultModel>(this, url, form, { headers: { Authorization: "Bearer " + this.$store.getters.token.Value } })
        .then(() => {
          this.$data.currentStep++;

          this.$cookies.remove("_g2g_identity_");

          const userPromise = this.$store.dispatch("updateUser", {} as IUserModel);
          const tokenPromise = this.$store.dispatch("updateToken", {} as ITokenModel);

          Promise.all([userPromise, tokenPromise]).then(() => {
            this.$store.dispatch("updateIsLoading", false);
            this.$data.isDeleteLoading = false;
            this.$router.push({ name: 'ConfirmDeletion' });
          });
        })
        .catch(error => {
          this.$data.isDeleteLoading = false;
          errorsService.handleErrors(this, error);
        });
    }

    private setData(): void {
      if (this.$data.RCEnvironment.VUE_APP_ENVIRONMENT == 'CREATIVE-ASSEMBLY') {
        this.$data.currentStep = 3;
        this.$data.hasCancelButton = false;
        this.$data.deletionSubtitle = "We're sorry to see you go";
        this.$data.deletionDescription = "To delete your account & associated data please contact our Customer Support team.";
        this.$data.deletionButtonLabel = "Contact";
        this.$data.deletionHasLink = true;
        this.$data.deletionLink = "https://support.sega.com/hc/requests/new?ticket_form_id=360003117578";
      }
    }
  }
